module.exports = __webpack_public_path__ + "static/media/bottom_banner_5_1.4468018b.png";